import React, { useEffect } from "react";

// Target default format
export const defaultAssessmentIssues = [
  { label: "Child labour", value: "" },
  { label: "Forced/Involuntary labour", value: "" },
  { label: "Sexual harassment", value: "" },
  { label: "Discrimination at workplace", value: "" },
  { label: "Wages", value: "" },
  { label: "Others", value: "" },
];

const PlantAssessmentTable = ({
  plantAssessmentData,
  setPlantAssessmentData,
}) => {
  useEffect(() => {
    if (
      !Array.isArray(plantAssessmentData) ||
      plantAssessmentData.length === 0
    ) {
      setPlantAssessmentData(defaultAssessmentIssues);
    }
  }, [plantAssessmentData, setPlantAssessmentData]);

  const handleChange = (index, value) => {
    const updated = [...plantAssessmentData];
    updated[index].value = value;
    setPlantAssessmentData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>Issue</th>
            <th style={headerStyle}>
              % of your plants and offices that were assessed <br />
              (by entity/statutory bodies/third parties)
            </th>
          </tr>
        </thead>
        <tbody>
          {plantAssessmentData.map((item, index) => (
            <tr key={item.label}>
              <td style={issueCellStyle}>{item.label}</td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Details"
                  value={item.value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
  backgroundColor: "#D3C9CE",
};

const issueCellStyle = {
  padding: "14px",
  border: "1px solid #000",
  fontWeight: "bold",
  backgroundColor: "#f8f4f6",
  textAlign: "left",
};

const cellStyle = {
  padding: "14px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "70%",
  padding: "10px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "6px",
  backgroundColor: "white",
  outline: "none",
  textAlign: "center",
};

export default PlantAssessmentTable;
